/**
 * Calculate the numbering for each item in the tree
 * @param {{index: number, level: number}[]} items
 * @returns {string[]} the numbering for each item in the tree
 */
function numberingForHeading(items) {
  const createTree = items => {
    const root = { index: 0, level: 0, numbering: '', parent: null };
    const tree = [root, ...items];

    tree.forEach((item, index) => {
      if (index === 0) return; // Skip root node
      const parent = tree
        .slice(0, index)
        .reverse()
        .find(i => i.level < item.level);

      item.parent = parent.index;
    });

    return tree;
  };

  const numbering = (item, j) => {
    if (item.parent === null) return;
    if (item.parent === 0) item.numbering = `${j + 1}`;
    else {
      const parent = tree.find(i => i.index === item.parent);
      item.numbering = `${parent.numbering}.${j + 1}`;
    }
  };

  // Goes over the tree in DFS to calculate the numbering
  const dfs = node => {
    tree
      .filter(item => item.parent === node.index)
      .forEach((item, i) => {
        numbering(item, i);
        dfs(item);
      });
  };

  const tree = createTree(items);
  dfs(tree[0]); // start from the root
  tree.shift(); // remove the root
  return tree.map(item => item.numbering);
}

export { numberingForHeading };
